import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';
import APIUrls from "../../../services/APIUrls.js";
import { FILE_TYPE_PREF,PREF_TYPE_FILE } from "../../../services/Util";
import { getAxiosResponse,putAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import Select from "react-select";
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import { transformBlankToNull } from '../../../services/Util';
import { RotatingLines } from "react-loader-spinner";
import Constants  from "../../../../src/Constants";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import { handleError } from "../../../services/authApiRoutes/APImethods";
export default function ProjectSettingEditOneReview() {
    const scrollRef = useRef(null);
    const { t } = useTranslation();
    const translate = t;
    const [departmentData,setDepartmentData]=useState([]);
    const params = useParams()
    const [department,setDepartment]=useState("department")
    const [departmentTags,setDepartmentTags]=useState([])
    const [departmentEnableEditing,setDepartmentEnableEditing]=useState(false)
    const [depData ,setDepData]=useState([{}])
	  const navigate = useNavigate();
    const[globalOverlay,showGlobalOverlay] = useState(true);
    const backRef = useRef();

    useEffect(()=>{
      getDepartments();
   },[])
   
   useEffect(()=>{
    if(departmentTags.length > 1){
     let res= departmentTags.filter(data=>data.value===0)
      if(res.length ===0){
        departmentTags.unshift({
          label:'Select All',
          value:0,
          id:0,
        })
      }
    }
   },[departmentTags])


   const getDepartments =()=>{
    Promise.all([
     getAxiosResponse(APIUrls.ALL_DEPARTMENT),
     getAxiosResponse(APIUrls.CUSTOMER_DEPARTMENNT_PREFRENCE),
    ]).then(async ([allDepartmentResponse, preferDepartmentResp]) => {
      if(allDepartmentResponse?.data?.code === 200){
        showGlobalOverlay(false)
        let  depData=allDepartmentResponse?.data?.data.filter(data=> +data.id === +params.id)
          setDepartment(depData[0])
        let prefrence=[];
        let nonPrefrence=[];
        for (const key in preferDepartmentResp?.data?.data) {
            if (Object.hasOwnProperty.call(preferDepartmentResp?.data?.data, key)) {
              const value = preferDepartmentResp?.data?.data[key];
              if(key === params.id){
                let depData=value.filter(dep=>(dep.status===Constants.ENABLE_DEP || dep.status===Constants.DISABLE_DEP) && FILE_TYPE_PREF[dep.preference]);
                 let enableEditting=value.filter(data=>data.preference ===Constants.ENABLE_REVIEWER_EDITING)
                setDepData([...depData,enableEditting[0]])
                setDepartmentEnableEditing(enableEditting[0].status==="true"?true:false)
                value.forEach(d=>{
                  if(d.status==="true"){
                    if(FILE_TYPE_PREF[d.preference]){
                    prefrence.push(FILE_TYPE_PREF[d.preference])
                    }
                  }else{
                    if(FILE_TYPE_PREF[d.preference]){
                      nonPrefrence.push(FILE_TYPE_PREF[d.preference])
                      }
                  }
                });
              }
            }
          } 
        setDepartmentData(prefrence)

        if(prefrence.length > 0 ){
         let finalTags= prefrence.map(data=>{
            return {
              label:data,
              value:data,
            }
          })
          let finalDepTagsData = finalTags.filter(y => !prefrence.some(x => x === y.value))
          setDepartmentTags(finalDepTagsData)
        }
        if(nonPrefrence.length > 0){
          let  finalpref=nonPrefrence.map(data=>{
            return {label:data,
                     value:data
                    }
          })
         setDepartmentTags([...departmentTags,...finalpref]) 
        }
      }else{
        throw new Error("Department API failed with response" + allDepartmentResponse.data.code);
        showGlobalOverlay(false)
      }
      if(preferDepartmentResp.data.code === 200){
        showGlobalOverlay(false)
      }else{
        throw new Error("Prefer Department API failed with response" + allDepartmentResponse.data.code);
        showGlobalOverlay(false)

      }
      backRef.current.focus()
    }).catch((err) => {
      handleError(err);
      showGlobalOverlay(false)

    })
   }


   const removeDepartmentTags=(tags)=>{
    const finalData=depData.map(data=>{
         if(data.preference===PREF_TYPE_FILE[tags]){
          data.status="false"
         }
         return data
    })
    setDepData(finalData)
    let dep=departmentData.filter(data=>data !==tags);
    let depTag=departmentData.filter(data=>data ===tags);
      setDepartmentData(dep)
    if(depTag[0] !==-1){
    setDepartmentTags([...departmentTags,{label:depTag[0],value:depTag[0]}])
    }
    
   }

      const  setDepartmentEnableEditingReviewer=(status)=>{
        if(status){
          const finalData=depData.map(data=>{
            if(data.preference===Constants.ENABLE_REVIEWER_EDITING){
             data.status="true"
            }
            return data
       })
       setDepData(finalData)
          setDepartmentEnableEditing(true)
        }else{
          const finalData=depData.map(data=>{
            if(data.preference===Constants.ENABLE_REVIEWER_EDITING){
             data.status="false"
            }
            return data
       })

       setDepData(finalData)
          setDepartmentEnableEditing(false)
        }
      }

   const addDepartmentTags=(event)=>{
    let tags=event.value;
    if( tags ===0 ){
      const finalData=depData.map(data=>{
         data.status="true"
        return data
   })
setDepartmentData(finalData.map(data=> FILE_TYPE_PREF[data?.preference]).filter(data=> data !==undefined))
   setDepData(finalData)
   setDepartmentTags([])
    }else if(tags ===-1){
      return
    }else{
      const finalData=depData.map(data=>{
        if(data.preference===PREF_TYPE_FILE[tags]){
         data.status="true"
        }
        return data
   })
   setDepData(finalData)
      let dep=departmentTags.filter(data=>data.value !==tags);
      let depTag=departmentTags.filter(data=>data.value ===tags);
      setDepartmentData([...departmentData,depTag[0].value])
      setDepartmentTags(dep)
    }
   }

const backToOneReview=()=>{
  navigate('/settings/project-setting-onereview')
}
  const submitBulkDepartmentTags=()=>{
    showGlobalOverlay(true)
   let obj={id:-1,preferences:depData,userGroup:department}
  putAxiosResponse(APIUrls.POST_BULK_DEPARTMENNT_PREFRENCE,transformBlankToNull(obj)).then(data=>{
    if(data.data.code === 200){
      showGlobalOverlay(false)
      navigate('/settings/project-setting-onereview')
    }
  }).catch(err=>{
    showGlobalOverlay(false)
  })
}

const crumbs = [
  {label:'Settings', url:'settings'},
  {label:'OneReview', url:'settings/project-setting-onereview'},
  {label:'Edit OneReview', url:''},
];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap">
           <Breadcrumb crumbs={ crumbs } />
             <div className="project-setting-page">
                <div className="project-heading userprofile-heading">
                    <div className="back-arrow flex-center">
                    <button onClick={()=>backToOneReview()} aria-label="back" ref={backRef}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                        <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z" fill="#1D4ED8"/>
                        </svg>
                    </button>
                    <span>Back to OneReview Settings</span>
                    </div>
                    <h3 className="flex">Edit OneReview Settings for {department.name}</h3>
                 </div>
                <div className="white-bg"> 
                    <div className="gb-setting-head">
                      <h6 className="mar-bot6">Additional File Format</h6>
                      <p>
                      When enabled, the next time you send out a project translating files in any of the enabled file formats,
                       your reviewers will be able to review translations line-by-line or in context in OPAL-Marketing.
                        Please note that to use OneReview, your translation vendors will be asked to translate files using the
                         industry-standard exchange format, XLIFF.
                     </p>
                    </div>
                    <div className="edit-one-review-block">
                      <div className="flex wrap-dropdown mb-0">
                          <div className="global-dropdown-block">
                              <div className="global-dropdown-select">
                                <label for="ect department tags"></label>
                              <Select menuShouldScrollIntoView={false}
                              closeMenuOnSelect={true} 
                              classNamePrefix='cw'
                               placeholder={"Select…."} 
                               onChange={event=>addDepartmentTags(event)} 
                               aria-label="select department tags"
                               options={departmentTags}/>
                          </div>
                          </div>
                      </div>
                      <div className="multiselect-output flex mar-bot40">
                        {departmentData && departmentData.length > 0 && departmentData.map((data,index)=>(
                          <button key={index} onClick={()=>removeDepartmentTags(data)} aria-label={"remove " + data} >
                          <strong>{data}</strong>
                          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                              <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                          </svg>
                          </button>
                        ))}
                       
                     </div>
                     <div className="flex allow-editing">
                        <strong>Allow Reviewer Editing</strong>
                       <div className="form-switch">
						             <input type="checkbox" checked={departmentEnableEditing} onChange={event=>setDepartmentEnableEditingReviewer(event?.target?.checked)} value={departmentEnableEditing} role="switch" aria-label="Allow Reviewer Editing" className="switch" />
							          </div>
                        </div>
                    </div>
                </div>
             </div>
          </div>
        </section>
      </div>
      <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
            <div>
            <button type="button" onClick={()=>backToOneReview()} className="btn-default">Cancel</button>
            </div>
            <div>
            <button onClick={()=>submitBulkDepartmentTags()}  className="btn-default">Save</button>
            </div>
        </div>
     </div> 
     <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div> 
    </div>
  );
}
